import React, { useEffect } from 'react';
import { t } from 'i18next';
import { useGenerateRoutingNumberHook } from './logic/useGenerateRoutingNumberMutation';
import { Header } from './Header';
import { useStore } from '../../store';
import Spinner, { SpinnerColor } from '../../generic-components/Spinner';

export const RoutingNumberChange = () => {
  const {
    user: { customerId },
    getPersonalAccount,
  } = useStore((state) => state);

  const {
    mutateAsync: generateReport,
    data: fileData,
    isLoading,
  } = useGenerateRoutingNumberHook({
    customerId,
    accountId: getPersonalAccount().accountExternalId,
  });
  useEffect(() => {
    generateReport();
  }, []);

  if (isLoading) {
    return (
      <div className='h-[100%] w-[100%]'>
        <Spinner spinnerColor={SpinnerColor.Blue} height='80px' width='80px' />
      </div>
    );
  }
  if (!fileData) return <div>{t('ROUTING_NUMBER.ERROR') as string}</div>;

  return (
    <div className='flex flex-col w-[100%] h-[100%]'>
      <Header srcLink={fileData.IframeUrl} />

      <div className=' w-12/12 h-[100%] flex justify-center '>
        <iframe
          data-testid='reportIframe'
          id='report'
          className='w-[80%] block h-[100%] mt-[50px]'
          title={t('ROUTING_NUMBER.TITLE')}
          src={fileData?.IframeUrl}
        />
      </div>
    </div>
  );
};
